const LOGO_URL = 'https://static.readdy.ai/image/358c420565fea72b91269b0160885e8f/345a23f26c025716610c41033cbf85f6.png';

export default function LandingFooter() {
  return (
    <footer className="py-16 px-6" style={{ background: '#030810' }}>
      <div className="max-w-3xl mx-auto text-center">
        {/* Logo + Brand */}
        <div className="mb-8 flex flex-col items-center">
          <img
            src={LOGO_URL}
            alt="EquilibradaMente™"
            className="w-20 h-20 object-contain mb-4"
          />
          <h2 className="text-xl font-semibold text-white mb-1">
            EQUILIBRADA<span style={{ color: '#F5A520' }}>MENTE</span>™
          </h2>
          <p className="text-xs tracking-widest mb-3" style={{ color: '#00C8E8' }}>
            CUIDE DA SUA MENTE. TRANSFORME SUA VIDA.
          </p>
          <p className="text-sm leading-relaxed max-w-md mx-auto" style={{ color: '#4A6A85' }}>
            Uma plataforma digital de apoio ao equilíbrio emocional, com uma experiência segura, guiada e acolhedora.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
          {['Política de Privacidade', 'Termos de Uso', 'Contato'].map(link => (
            <a
              key={link}
              href="#"
              rel="nofollow"
              className="text-sm cursor-pointer"
              style={{
                color: '#3A6A85',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.color = '#00C8E8'}
              onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.color = '#3A6A85'}
            >
              {link}
            </a>
          ))}
        </div>

        {/* Divider */}
        <div
          className="w-16 h-px mx-auto mb-8"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(0,200,232,0.3), transparent)' }}
        />

        {/* Signature */}
        <div>
          <p className="text-sm font-medium text-white mb-1">Criado por</p>
          <p className="text-base font-semibold mb-1" style={{ color: '#00C8E8' }}>
            Reginaldo Silva
          </p>
          <p className="text-sm" style={{ color: '#3A6A85' }}>
            Psicoterapeuta clínico
          </p>
          <p className="text-xs mt-2 leading-relaxed" style={{ color: '#2A4A65' }}>
            Especialista em hipnose clínica, psicanálise e princípios de neurociência
          </p>
        </div>

        <p className="text-xs mt-10" style={{ color: '#1A3A55' }}>
          © {new Date().getFullYear()} Equilibrada🧠Mente™. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}